import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/ApolloNextAppProvider.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/hooks.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["ExploreProgramsBtn","ExploreScholarshipBtn"] */ "/home/ubuntu/frontend/src/components/atoms/Buttons/ExploreButtons/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/atoms/StripDataMoveable/StripDataMoveable.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/common/Analytics/CustomButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/Carousels/HeroCarousel/ClientSideButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/Carousels/HeroCarousel/ClientWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/Carousels/HeroCarousel/HeroCarousel.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/CustomCarousels/Carousel.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/SectionCard/SectionCard.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/StripData/StripDataNew.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/sections/BlogList/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/sections/NewLists/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/sections/WhyAmityCard/WhyAmity.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/sections/CareerServices/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/sections/WhyAmityCard/WhyAmityItemClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/templates/LpStudentTestimonial/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/molecules/SectionCard/SectionCard.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/molecules/SectionCardWithBg/SectionCard.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/sections/Faculties/Faculties.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/organisms/BrandWrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/organisms/FacultyCarousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/organisms/FaqWithCategory/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/organisms/HolisticCareerServicesSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/organisms/LeadForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/organisms/SimilarProgramSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/sections/BannerCard/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/sections/BannerCtaWithDesc/style.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/sections/DegreeProgram/style.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/sections/BrandLogos/Brandlogo.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/sections/NewsStories/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/sections/FaqSection/FaqSection.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/revamp/sections/Blogs/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/sections/StudentTestimonial/index.tsx");
